type Entry = {
	index: number;
	value: string;
};

export const addSortedIntoFilterArray = (
	currentFilters: Array<string>,
	referenceFilters: Array<string>,
	newElement: string,
) => {
	if (!currentFilters || !referenceFilters || !newElement) return [];

	const newFilters: Array<string> = [];

	if (currentFilters.length < 1) {
		newFilters.push(newElement);
		return newFilters;
	}

	const items: Array<Entry> = [];

	currentFilters.forEach((item) => {
		const idx = referenceFilters.findIndex((refs) => {
			return refs === item;
		});

		if (idx === -1) {
			// Error: value is not a possible filter
			return [];
		}

		items.push({ index: idx, value: item });
	});

	const idx = referenceFilters.findIndex((refs) => {
		return refs === newElement;
	});

	if (idx === -1) {
		// Error: value is not in the range of possible filters
		return [];
	}

	items.push({ index: idx, value: newElement });

	items.sort((a, b) => {
		return a.index - b.index;
	});

	const sortedArray: Array<string> = [];

	items.forEach((itm) => {
		sortedArray.push(itm.value);
	});

	return sortedArray;
};
